import { expensesApi } from '../api/expensesApi'
import type { ExpenseApprovalData } from '../schema/expensesSchema'

export const approveExpense = async (expenseApproval: ExpenseApprovalData) => {
  try {
    const { data } = await expensesApi.approveExpense(expenseApproval)
    return data
  } catch (error) {
    console.error(`Error approving/rejecting expense: `, error)
    throw error
  }
}
